/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type NeoletterUserProfileCustomFieldsInput = {
  active_project_id?: string | null
  sidebar_is_expanded?: string | null
}

export type NeoletterUserProfileInput = {
  company?: string | null
  custom_fields?: NeoletterUserProfileCustomFieldsInput | null
  email?: string | null
  family_name?: string | null
  given_name?: string | null
  id?: string | null
  name?: string | null
  phone_number?: string | null
  position?: string | null
  salutation?: string | null
  staff?: boolean | null
}

export type UpdateNeoletterUserProfileMutationVariables = Exact<{
  input: Types.NeoletterUserProfileInput
}>

export type UpdateNeoletterUserProfileMutation = {
  __typename: "Mutation"
  neoletterUserProfile?: {
    __typename: "NeoletterUserProfile"
    dummy_property?: string | null
  } | null
}

export const UpdateNeoletterUserProfileDocument = gql`
  mutation UpdateNeoletterUserProfile($input: NeoletterUserProfileInput!) {
    neoletterUserProfile: updateNeoletterUserProfile(input: $input)
      @rest(
        type: "NeoletterUserProfile"
        method: "PUT"
        endpoint: "userProfile"
        path: ""
      ) {
      dummy_property
    }
  }
`
export type UpdateNeoletterUserProfileMutationFn = Apollo.MutationFunction<
  UpdateNeoletterUserProfileMutation,
  UpdateNeoletterUserProfileMutationVariables
>

/**
 * __useUpdateNeoletterUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateNeoletterUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNeoletterUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNeoletterUserProfileMutation, { data, loading, error }] = useUpdateNeoletterUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNeoletterUserProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNeoletterUserProfileMutation,
    UpdateNeoletterUserProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UpdateNeoletterUserProfileMutation,
    UpdateNeoletterUserProfileMutationVariables
  >(UpdateNeoletterUserProfileDocument, options)
}
export type UpdateNeoletterUserProfileMutationHookResult = ReturnType<
  typeof useUpdateNeoletterUserProfileMutation
>
export type UpdateNeoletterUserProfileMutationResult =
  Apollo.MutationResult<UpdateNeoletterUserProfileMutation>
export type UpdateNeoletterUserProfileMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNeoletterUserProfileMutation,
    UpdateNeoletterUserProfileMutationVariables
  >
